// creates the correct filters for all page types
import { computed } from 'vue'
import { usePageStore } from '~/store/page'

export const useGridFilters = () => {
  const pageStore = usePageStore()
  const currentPage = pageStore.getCurrentPage

  const filters = computed(() => {
    if (currentPage) {
      if (currentPage.collection === 'person_page') {
        const filters = [{ id: currentPage.id, collection: currentPage.collection }]
        return filters
      } else if (currentPage.belongs_to) {
        // detail pages
        const filters = [{ id: currentPage.id, collection: currentPage.collection }]
        currentPage.belongs_to.forEach((relation) => {
          if (relation.item) {
            filters.push({ id: relation.item.id, collection: relation.collection })
          }
        })

        return filters
      } else if (currentPage.collection === 'home_page') {
        return
      } else {
        // overview page, program page, homepage
        return [{ id: currentPage.id, collection: currentPage.collection }]
      }
    }

    return []
  })

  return filters
}
